import { Component, effect, input, signal } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faLock, faQuestion } from '@fortawesome/pro-solid-svg-icons';
import { RidProgress, RidProgressDot } from '../rid-progress-dot/rid-progress-dot';

/** MYSTERY: open to choose, but its name stays hidden until it's chosen. */
export type RidMapLabelState = 'LOCKED' | 'MYSTERY' | 'FINISHED' | 'OPEN';

/** A sign on a map naming a province or location, with a dot per part of it (its locations or stops) showing how far that part is. Locked it's only a lock, and a mystery (to choose from, not known yet) only a question mark, both the same size for every label; finished it's a smaller, green card. Pulsing, a ring keeps rippling out of it, to call the player there. Once a mystery is decided, its question mark morphs into its name when it's chosen or into a lock when it isn't, so the change reads as the outcome of the choice. */
@Component({
  selector: 'rid-map-label',
  imports: [FaIconComponent, RidProgressDot],
  templateUrl: './rid-map-label.html',
  host: {
    class: 'stack place-items-center',
  },
})
export class RidMapLabel {
  name = input.required<string>();
  /** How far each part is, in order. */
  dots = input.required<RidProgress[]>();
  state = input.required<RidMapLabelState>();
  /** Only shown on an open or finished label. */
  pulsing = input(false);

  /** The state it changed from while on screen; unset when it's first shown, so it only animates the changes the player sees happen. */
  protected readonly changedFrom = signal<RidMapLabelState | undefined>(undefined);

  protected readonly faLock = faLock;
  protected readonly faQuestion = faQuestion;

  constructor() {
    // kept by an effect, not derived lazily (a linkedSignal), as the template doesn't read it in every state, so it would miss those
    let previous: RidMapLabelState | undefined;
    effect(() => {
      const state = this.state();
      this.changedFrom.set(previous);
      previous = state;
    });
  }
}
